angular.module('app').factory('casinoGameService', [
    'Restangular',
    'settings',
    function (Restangular, settings) {
        var restAngular = Restangular.withConfig(function (Configurer)
        {
            Configurer.setBaseUrl(settings.apiURL);
        });

        restAngular = restAngular.all("/CasinoGame/");

        return {
            create: function (requestData) {
                return restAngular.
                    one("create").
                    post("", requestData)
            },
            get: function (requestData) {
                return restAngular.
                    one("get").
                    customGET(param(requestData))
            },
            getSkins: function (requestData) {
                return restAngular.
                    one("getSkins").
                    customGET(param(requestData || {}))
            },
            getSkinGames: function (requestData) {
                return restAngular.
                    one("getSkinGames").
                    customGET(param(requestData))
            },
            getSkinGamesPart: function (requestData) {
                return restAngular.
                    one("getSkinGamesPart").
                    customGET(param(requestData))
            },
            edit: function (requestData) {
                return restAngular.
                    one("change").
                    post("", requestData)
            },
            editSkinGame: function (requestData) {
                return restAngular.
                    one("changeSkinGame").
                    post("", requestData)
            },
            editSkinGameFull: function (requestData) {
                return restAngular.
                    one("changeSkinGameFull").
                    post("", requestData)
            },
            changeOrder: function (requestData) {
                return restAngular.
                    one("changeOrder").
                    post("", requestData)
            },
            changeOrderSkinGames: function (requestData) {
                return restAngular.
                    one("changeOrderSkinGames").
                    post("", requestData)
            },
            deleteGame: function (request) {
                var requestData = {
                    id: request.id,
                    status: request.status === 'published' ? "archive" : 'published',
                    comment: request.comment
                };
                return restAngular.
                    one("changeitem").
                    post("", requestData)
            },
            toggleItemInactive: function (request) {
                var requestData = {
                    id: request.id,
                    status: request.status !== 'Publish' ? "inactive" : "published",
                    comment: request.comment
                };
                return restAngular.
                one("changeitem").
                post("", requestData)
            },
            publishGame: function (gameId) {
                var requestData = {
                    id: gameId,
                    status: "published"
                };
                return restAngular.
                    one("change").
                    post("", {casinoGame: requestData})
            },
            attachGameOld: function (requestData) {
                return restAngular.
                    one("attachGameOld").
                    post("", requestData)
            },
            switchSkinsOld: function (requestData) {
                return restAngular.
                one("switchSkinsOld").
                post("", requestData)
            },
            attachGame: function (requestData) {
                return restAngular.
                    one("attachGame").
                    post("", requestData)
            },
            switchSkins: function (requestData) {
                return restAngular.
                one("switchSkins").
                post("", requestData)
            },
            switchSkinsGames: function (requestData) {
                return restAngular.
                    one("switchSkinsGames").
                    post("", requestData)
            },
            joinSkinsGames: function (requestData) {
                return restAngular.
                    one("joinSkinsGames").
                    post("", requestData)
            },
            getProvidersGroups: function (requestData) {
                return restAngular.
                    one("getGroupedProviders").
                    customGET(param(requestData))
            },
            getSkinProvidersGroups: function (requestData) {
                return restAngular.
                    one("getSkinGroupedProviders").
                    customGET(param(requestData))
            },
            createGameSkinWinner: function (requestData) {
                return restAngular.
                    one("createGameSkinWinner").
                    post("", requestData)
            },
            editGameSkinWinner: function (requestData) {
                return restAngular.
                    one("changeGameSkinWinner").
                    post("", requestData)
            },
            getGameSkinWinners: function (requestData) {
                requestData = !!requestData ? param(requestData) : undefined;
                return restAngular.
                    one("getGameSkinWinners").
                    customGET(requestData)
            },
            getGameSkinWinner: function (requestData) {
                requestData = !!requestData ? param(requestData) : undefined;
                return restAngular.
                    one("getGameSkinWinner").
                    customGET(requestData)
            },
            editWinner: function (requestData) {
                return restAngular.
                    one("getGameSkinWinners").
                    post("", requestData)
            },
            deleteWinnerById: function (requestData) {
                return restAngular.
                    one("getGameSkinWinners").
                    post("", requestData)
            },
            getSkinListByGame: function (requestData) {
                return restAngular.
                one("getSkinListByGame").
                customGET(param(requestData))
            },
            getUnapprovedGamesCount: function (requestData) {
                return restAngular.
                one("getUnapprovedGamesCount").
                customGET(param(requestData))
            },
            getExtraCategories: function (requestData) {
                return restAngular.
                one("getExtraCategories").
                customGET(param(requestData))
            },
            getForReport: function (requestData) {
                return restAngular.
                one("getForReport").
                customGET(param( requestData))
            }
        }
    }
]);
